
(function () {
  'use strict';

  var d = document;
  var r = d.documentElement;

  // Prevent duplicate initialization.
  if (d.getElementById('cv-scroll')) return;

  var el = d.createElement('div');
  el.id = 'cv-scroll';
  el.setAttribute('aria-hidden', 'true');

  el.innerHTML =
    '<div class="cv-rail"><div class="cv-fill"></div></div>' +
    '<div class="cv-thumb"><span class="cv-pill"></span><span class="cv-badge">⚡</span></div>';

  d.body.appendChild(el);
  r.classList.add('cv-has-scroll');

  var thumb = el.querySelector('.cv-thumb');
  var fill = el.querySelector('.cv-fill');

  var raf = 0;
  var hideT = 0;
  var drag = null;
  var hover = false;

  // Cached geometry; refreshed on resize or content-size changes.
  var maxScroll = 0;
  var travelDistance = 0;
  var viewportHeight = window.innerHeight;
  var measured = false;

  function measure() {
    // Read layout before writing styles.
    viewportHeight = window.innerHeight;
    maxScroll = Math.max(
      0,
      r.scrollHeight - viewportHeight
    );

    travelDistance = Math.max(
      0,
      el.clientHeight -
      thumb.offsetTop * 2 -
      thumb.offsetHeight
    );

    measured = true;
  }

  function update() {
    raf = 0;

    // First render or fallback if measurements are unavailable.
    if (!measured) measure();

    var p = maxScroll > 0
      ? Math.min(1, Math.max(0, window.scrollY / maxScroll))
      : 0;

    el.classList.toggle('cv-none', maxScroll <= 2);

    // Transform-only updates avoid repeated layout reads.
    thumb.style.transform =
      'translate3d(0,' + (p * travelDistance) + 'px,0)';

    fill.style.transform = 'scaleY(' + p + ')';
  }

  function queue() {
    if (raf) return;

    raf = requestAnimationFrame(update);
  }

  function refresh() {
    // Batch measurement and rendering into one animation frame.
    if (raf) cancelAnimationFrame(raf);

    raf = requestAnimationFrame(function () {
      raf = 0;
      measure();
      update();
    });
  }

  function wake() {
    el.classList.add('cv-on');

    clearTimeout(hideT);

    hideT = setTimeout(function () {
      if (!drag && !hover) {
        el.classList.remove('cv-on');
      }
    }, 1200);
  }

  window.addEventListener('scroll', function () {
    queue();
    wake();
  }, { passive: true });

  window.addEventListener('resize', refresh, { passive: true });

  // Recalculate only when document dimensions change.
  if ('ResizeObserver' in window) {
    var resizeObserver = new ResizeObserver(function () {
      refresh();
    });

    resizeObserver.observe(r);
    resizeObserver.observe(d.body);
  }

  el.addEventListener('pointerenter', function (e) {
    if (e.pointerType !== 'mouse') return;

    hover = true;
    el.classList.add('cv-on');
    clearTimeout(hideT);
  });

  el.addEventListener('pointerleave', function (e) {
    if (e.pointerType !== 'mouse') return;

    hover = false;
    wake();
  });

  thumb.addEventListener('pointerdown', function (e) {
    e.preventDefault();

    drag = {
      y: e.clientY,
      s: window.scrollY
    };

    r.style.scrollBehavior = 'auto';
    thumb.setPointerCapture(e.pointerId);
    el.classList.add('cv-drag');
  });

  thumb.addEventListener('pointermove', function (e) {
    if (!drag || maxScroll <= 0 || travelDistance <= 0) return;

    window.scrollTo(
      0,
      drag.s +
      (e.clientY - drag.y) * maxScroll / travelDistance
    );
  });

  function endDrag() {
    if (!drag) return;

    drag = null;
    r.style.scrollBehavior = '';
    el.classList.remove('cv-drag');
    wake();
  }

  thumb.addEventListener('pointerup', endDrag);
  thumb.addEventListener('pointercancel', endDrag);
  thumb.addEventListener('lostpointercapture', endDrag);

  el.addEventListener('pointerdown', function (e) {
    if (e.target.closest('.cv-thumb')) return;

    // One geometry read on user interaction, not on every scroll.
    var bounds = thumb.getBoundingClientRect();

    window.scrollBy({
      top: (e.clientY < bounds.top ? -1 : 1) *
        viewportHeight * 0.85,
      behavior: 'smooth'
    });
  });

  refresh();
})();
